import { useQuery } from "urql";

import { GetSyncerStatusDocument, TroubleshootingStatsDocument } from "@/gen/graphql";

export function useTroubleshootingStats() {
    const [{ data, fetching, error }] = useQuery({
        query: TroubleshootingStatsDocument,
        requestPolicy: "cache-and-network",
    });

    const [{ data: syncerData }] = useQuery({
        query: GetSyncerStatusDocument,
        requestPolicy: "cache-and-network",
    });

    const missingTrialResults = data?.troubleshootingStats?.missingTrialResults?.length || 0;
    const stalledGames = data?.troubleshootingStats?.stalledGames?.length || 0;

    const syncerDown =
        syncerData?.syncerStatus && syncerData.syncerStatus.state?.toLowerCase() !== "started"
            ? 1
            : 0;

    const totalIssues = missingTrialResults + stalledGames + syncerDown;

    return {
        missingTrialResults,
        stalledGames,
        syncerDown,
        totalIssues,
        fetching,
        error,
    };
}
